import formatDateTime from "./formatDateTime";
import parseDate from "./parseDate";

const renderDateTime = (value: unknown, timezone?: string | null) => {
  const dateValue = parseDate(value);

  if (!dateValue) {
    return "-";
  }

  return formatDateTime(dateValue, timezone);
};

export default renderDateTime;
